import { render } from "./UpdateAdressComponent.vue?vue&type=template&id=7e5d870f"
import script from "./UpdateAdressComponent.vue?vue&type=script&lang=js"
export * from "./UpdateAdressComponent.vue?vue&type=script&lang=js"

import "./UpdateAdressComponent.vue?vue&type=style&index=0&id=7e5d870f&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__